import React from "react";
import { useOnlineStatus } from "../../../hooks/useOnlineStatus";
import { MobilePhotoAction } from "../../../data/MobilePhotoAction";

export default function FilePicker({
  buttonClass,
  buttonLabel,
  handleChange,
  uploadMore,
  labelIdentifier,
  disable,
  mobileAction = MobilePhotoAction.NONE
}) {
  const label = labelIdentifier ?? "file-picker";
  const isOnline = useOnlineStatus();

  const setAdditionalAttributes = () =>
    mobileAction === MobilePhotoAction.TAKE_PHOTO
      ? { accept: "image/*", capture: "environment" }
      : mobileAction === MobilePhotoAction.NONE
        ? { accept: "image/*" }
        : {};
  return (
    <>
      <label
        htmlFor={label}
        className={`ch-btn ${buttonClass}`}
        disabled={!isOnline || disable}
      >
        {uploadMore && <span className="icon-upload-more" />}
        {buttonLabel}
      </label>
      <input
        className="ch-width--12 file-picker"
        id={label}
        type="file"
        onChange={(e) => {
          if (isOnline) handleChange([...e.target.files], mobileAction);
        }}
        multiple
        {...setAdditionalAttributes()}
      />
    </>
  );
}
